import {PhoneHQGlyph} from 'ch3-ui-lib';
import {Call} from "../store/features/calls/callsService";


export const getCallType = (callType: any, bridgetAt: any, forwarded: any, iconClassName?: string) => {
    if (forwarded) {
        return <PhoneHQGlyph name='phone_forwarded' size={20}/>;
    }
    else if (!forwarded  &&!bridgetAt) {
        switch (callType) {
            case 'OUTBOUND':
                return <PhoneHQGlyph name='call_made' size={20} className={'text-ink-muted ' + (iconClassName ?? '')}/>;
            case 'INBOUND':
                return <PhoneHQGlyph name='call_missed' size={20} className={'text-danger-ink ' + (iconClassName ?? '')}/>;
            default:
                return null;
        }
    } else {
        switch (callType) {
            case 'OUTBOUND':
                return <PhoneHQGlyph name='call_made' size={20} className={'text-ink-muted ' + (iconClassName ?? '')}/>;
            case 'INBOUND':
                return <PhoneHQGlyph name='call_received' size={20} className={'text-ink-muted ' + (iconClassName ?? '')}/>;
            default:
                return null;
        }
    }
};


export const getCallTypeDescription = (callType: string, bridgetAt:string, forwardedTo:any) => {
    if (!bridgetAt && !forwardedTo) {
        if (callType === 'OUTBOUND') {
            return 'Missed outgoing call';
        }
        if (callType === 'INBOUND') {
            return 'Missed incoming call';
        }
    } else {
        switch (callType) {
            case 'OUTBOUND':
                return 'Outgoing call';
            case 'INBOUND':
                return 'Incoming call';
            default:
                return null;
        }
    }
};

export function getCallDescription(call: Call | undefined): any {
    if(!call) return  'Unknown call type';
    if (call.forwardedTo) {
        return (
            <div className="flex flex-col">
                <p className="mr-2">Call forwarded to </p>
            </div>);
    }

    if (call.type === 'OUTBOUND' && call.bridgetAt) {
        return 'Outgoing call';
    }
    if (call.type === 'OUTBOUND' && !call.bridgetAt) {
        return 'Missed outgoing call';
    }
    if (call.type === 'INBOUND' && !call.bridgetAt) {
        return 'Missed incoming call';
    }
    if (call.type === 'INBOUND' && call.bridgetAt) {
        return 'Incoming call';
    }
    return 'Unknown call type';
}

export const isGroupCall = (call: Call | undefined): boolean => call?.callType === 'CONFERENCE';

export const isMissedGroupCall = (call: Call): boolean =>
    isGroupCall(call) && (call.myOutcome === 'MISSED' || call.myOutcome === 'DECLINED');

export function isMissedIncomingCall(call: Call) {
    if (isGroupCall(call)) {
        return isMissedGroupCall(call);
    }
    if (!call.bridgetAt && !call.forwardedAt && call.type === 'INBOUND') {
        return true;
    }
}


